




























































import {defineComponent, PropType, ref} from "@vue/composition-api";
import AuthLayout from "@tool/Layouts/AuthLayout.vue";
import useFormHelper from "@tool/Helpers/useFormHelper";
import FormError from "@tool/Components/FormError.vue";
import useAxios from "@tool/Helpers/useAxios";
import {TeamInvitationEntityInterface} from "@tool/tool.types";
import {useInertia} from "@tool/Helpers/useInertia";
import useSwal from "@tool/Helpers/useSwal";

interface LoginAndRegisterResponse {
    redirectUrl: string;
    acceptedInvitation: null | boolean
}

export default defineComponent({
    components: {
        AuthLayout,
        FormError
    },
    props: {
        mode: {
            type: String as PropType<'login' | 'register'>,
            required: true
        },
        team_invitation: {
            type: Object as PropType<TeamInvitationEntityInterface>,
            required: false
        }
    },
    setup(props) {
        const redirecting = ref(false);

        const mainTitle = props.mode === 'register' ? 'Create a FREE Account' : 'Login';
        const title = props.team_invitation ? mainTitle + ' TO ACCEPT INVITATION' : mainTitle;

        const registerForm = useFormHelper({
            name_first: '',
            email: '',
            password: '',
            password_confirmation: '',
        }, {
            email: 'Email'
        });

        const swalMessageAboutInvitation = (state: boolean) => {
            if (state) {
                useSwal().fire({
                    title: 'Invitation Accepted!',
                    text: 'You successfully accepted the invitation to join the team!',
                    icon: 'success'
                });
            } else {
                useSwal().fire({
                    title: 'Invitation not accepted',
                    text: 'There was a problem accepting your invitation. Please try again clicking the link in the email or contact our support!',
                    icon: 'error'
                });
            }
        }

        const registerSubmit = async () => {
            const response = await registerForm.value.submit(async (data) => {
                return useAxios().post<LoginAndRegisterResponse>(route('auth.register.post'), {
                    name_first: data.name_first,
                    email: data.email,
                    password: data.password,
                    password_confirmation: data.password_confirmation,
                    terms: true,
                    team_invitation: props.team_invitation ? props.team_invitation.id : null,
                })
            });

            const successResponse = response.success;

            if (successResponse) {
                redirecting.value = true;
                useInertia().get(successResponse.redirectUrl, {}, {
                    onFinish() {
                        if (successResponse.acceptedInvitation === null) {
                            return;
                        }

                        swalMessageAboutInvitation(successResponse.acceptedInvitation);
                    }
                })
            }
        }

        const loginForm = useFormHelper({
            email: '',
            password: '',
            remember: true
        }, {
            'email': 'Email',
            'password': 'Password'
        });

        const loginSubmit = async () => {
            const response = await loginForm.value.submit(async (data) => {
                return useAxios().post<LoginAndRegisterResponse>(route('auth.login.post'), {
                    email: data.email,
                    password: data.password,
                    team_invitation: props.team_invitation ? props.team_invitation.id : null,
                })
            });

            const successResponse = response.success;

            if (successResponse) {
                redirecting.value = true;
                useInertia().get(successResponse.redirectUrl, {}, {
                    onFinish() {
                        if (successResponse.acceptedInvitation === null) {
                            return;
                        }

                        swalMessageAboutInvitation(successResponse.acceptedInvitation);
                    }
                })
            }
        }

        return {
            title,
            redirecting,
            // Register
            registerForm,
            registerSubmit,
            // Login
            loginForm,
            loginSubmit,
        }
    },
});
